import { render, staticRenderFns } from "./rejection-reasons.vue?vue&type=template&id=ea825334&"
import script from "./rejection-reasons.vue?vue&type=script&lang=js&"
export * from "./rejection-reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports